import { bus } from '../core/event-bus.js';
import { playerManager } from '../core/player-manager.js';

let endCardMeta = [];
let cachedEndCardIndices = [];

export function initEndCard() {
  const overlay = document.getElementById('endcard-overlay');
  const content = document.getElementById('endcard-content');
  const closeBtn = document.getElementById('endcard-close');

  closeBtn.addEventListener('click', () => {
    _hideEndCard(overlay, content);
  });

  bus.on('vast:companionsParsed', (companions) => {
    endCardMeta = companions.filter(c => c.renderingMode === 'end-card');
    if (endCardMeta.length > 0) {
      console.log(`[EndCard] ${endCardMeta.length} companion(s) marked as end-card`);
    }
    // Parsed data may arrive after adstarted (async fetch), so resolve now if ad is on stage
    if (endCardMeta.length > 0 && playerManager.rmpVast?.adOnStage) {
      _resolveEndCardIndices();
    }
  });

  bus.on('ad:event', ({ type }) => {
    if (type === 'adstarted') {
      _resolveEndCardIndices();
    }
  });

  bus.on('ad:event', ({ type }) => {
    if (type === 'adcomplete') {
      if (cachedEndCardIndices.length === 0) return;
      _showEndCard(overlay, content);
    }
  });

  bus.on('session:started', () => {
    _hideEndCard(overlay, content);
    endCardMeta = [];
    cachedEndCardIndices = [];
  });
  bus.on('session:reset', () => {
    _hideEndCard(overlay, content);
    endCardMeta = [];
    cachedEndCardIndices = [];
  });

  bus.on('ad:event', ({ type }) => {
    if (type === 'aderror' || type === 'addestroyed') {
      if (!overlay.classList.contains('hidden') && type === 'addestroyed') return;
      if (type === 'aderror') _hideEndCard(overlay, content);
    }
  });
}

function _resolveEndCardIndices() {
  cachedEndCardIndices = [];
  if (endCardMeta.length === 0) return;

  const rv = playerManager.rmpVast;
  if (!rv) return;

  try {
    const list = rv.getCompanionAdsList(2000, 2000);
    if (!list || list.length === 0) return;

    for (let i = 0; i < list.length; i++) {
      const c = list[i];
      const match = endCardMeta.find(
        m => Number(m.width) === Number(c.width) && Number(m.height) === Number(c.height)
      );
      if (match) {
        cachedEndCardIndices.push({ rmpIndex: i, width: c.width, height: c.height });
      }
    }
  } catch (e) {
    console.warn('[EndCard] Error resolving end-card indices:', e);
  }
}

function _showEndCard(overlay, content) {
  if (cachedEndCardIndices.length === 0) return;

  const rv = playerManager.rmpVast;
  if (!rv) return;

  const sorted = [...cachedEndCardIndices].sort((a, b) => {
    return (b.width * b.height) - (a.width * a.height);
  });

  const best = sorted[0];
  content.innerHTML = '';

  const adEl = rv.getCompanionAd(best.rmpIndex);
  if (adEl) {
    if (adEl.tagName === 'IFRAME') {
      adEl.style.width = `${best.width}px`;
      adEl.style.height = `${best.height}px`;
      adEl.style.maxWidth = '100%';
      adEl.style.maxHeight = '100%';
    }
    content.appendChild(adEl);
    overlay.classList.remove('hidden');
  }
}

function _hideEndCard(overlay, content) {
  overlay.classList.add('hidden');
  content.innerHTML = '';
}
